// extracted by mini-css-extract-plugin
module.exports = {"waldorfFooterWrapper":"style_waldorfFooterWrapper__xQW68","waldorfFooterInner":"style_waldorfFooterInner__QTTn7"};